<template>
  <d2-container>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="listQuery.keyword" placeholder="请输入订单/客户手机号" clearable size="small" style="width: 200px;" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="listQuery.status" placeholder="请选择状态" clearable size="small" style="width: 200px;">
          <el-option label="初始化" value="0"></el-option>
          <el-option label="待制作" value="1"></el-option>
          <el-option label="已完成" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          class="filter-item"
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="getSearch(1)"
        >搜索</el-button>
      </el-form-item>
    </el-form>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="客户手机号">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status === 0">初始化</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status === 1">待制作</el-tag>
          <el-tag type="success" v-else-if="scope.row.status === 2">已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.type === 0">视频</el-tag>
          <el-tag type="warning" v-else-if="scope.row.type === 1">文字</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="AR密语编号">
        <template slot-scope="scope">
          <span>{{ scope.row.arMsgCode }}</span>
          <el-button type="text" size="small" @click="copy(scope.row.arMsgCode)">复制</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="小程序短链">
        <template slot-scope="scope">
          <span>{{ scope.row.shortLink }}</span>
          <el-button type="text" size="small" @click="copy(scope.row.shortLink)">复制</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="密语卡二维码">
        <template slot-scope="scope">
         <div v-if="scope.row.qrCode" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
           <el-image :src="scope.row.qrCode" style="width: 80px;height: 80px;cursor: pointer;" :preview-src-list="[scope.row.qrCode]"></el-image>
            <el-button type="text" size="small" @click="printQrCode(scope.row.qrCode)">打印</el-button>
         </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="制作结果">
        <template slot-scope="scope">
          <video v-if="scope.row.arMsgRes && scope.row.type == 0"  @click="openVideo(scope.row.arMsgRes)" :src="scope.row.arMsgRes" style="width: 80px;height: 80px;cursor: pointer;" :controls="false" />
          <el-button v-if="scope.row.arMsgRes && scope.row.type == 0" type="text" size="small" @click="openVideo(scope.row.arMsgRes)">播放</el-button>
          <div v-if="scope.row.arMsgRes && scope.row.type == 1">
            <div class="text-ellipsis" @click="showTextDialog(scope.row)">
              {{ scope.row.arMsgRes.slice(0, 20) }}{{ scope.row.arMsgRes.length > 20 ? '...' : '' }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频格式" width="130">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 0 && scope.row.videoFormat === 'rgb-alpha-mask'" type="success">透明视频</el-tag>
          <el-tag v-else-if="scope.row.type === 0" type="info">普通视频</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="客服备注">
        <template slot-scope="scope">
          <span>{{ scope.row.kefuRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="220">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit"
            size="mini"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            icon="el-icon-delete"
            size="mini"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
          <el-button
            icon="el-icon-download"
            size="mini"
            type="primary"
            v-if="scope.row.status > 0"
            @click="downloadMaterial(scope.row.id,scope.row.paramsJson)"
            style="margin-top: 10px;"
          >下载素材</el-button>
          <el-button

            icon="el-icon-video-camera"
            size="mini"
            type="primary"
            v-if="scope.row.status > 0"
            @click="submitOrder(scope.row.id, scope.row.type)"
            style="margin-top: 10px;"
          >提交制作</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog :visible.sync="dialogFormVisible"  :title="textMap[dialogStatus]" width="60%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="商品" prop="goodsId">
          <div>
            <div v-for="item in goodsList" :key="item.id" @click="selectGoods(item.id)" style="display: flex; align-items: center; margin-bottom: 10px;">
              <el-image :src="item.goodsImg" style="width: 40px; height: 40px; margin-right: 10px;" :preview-src-list="[item.goodsImg]"></el-image>
              <span :class="{'active': form.goodsId == item.id}">{{ item.name }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="订单名称" prop="name">
          <el-input v-model="form.name" size="small" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="客户手机号" prop="mobile">
          <el-input v-model="form.mobile" size="small" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="客服备注" prop="kefuRemark">
          <el-input v-model="form.kefuRemark" size="small" placeholder="请输入客服备注" />
        </el-form-item>
        <el-form-item label="密语编号" prop="arMsgCode">
          <el-input v-model="form.arMsgCode" size="small" placeholder="请输入密语编号" />
        </el-form-item>
      </el-form>
      <!-- 测试 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="commitFormVisible" title="提交制作" width="60%">
      <el-form
        :model="commitForm"
        :rules="commitForm.type === 0 ? commitRules : textCommitRules"
        ref="commitForm"
        label-width="100px"
      >
        <el-form-item v-if="commitForm.type === 0" label="制作结果" prop="arMsgRes">
          <!-- 视频订单上传成品视频 -->
          <UploadVideo v-model="commitForm.arMsgRes" :max="1"/>
        </el-form-item>
        <el-form-item v-else label="文字密语" prop="arMsgRes">
          <el-input
            v-model="commitForm.arMsgRes"
            type="textarea"
            :rows="8"
            maxlength="520"
            show-word-limit
            placeholder="请输入文字密语"
          />
        </el-form-item>
        <el-form-item v-if="commitForm.type === 0" label="视频类型" prop="videoFormat">
          <el-radio-group v-model="commitForm.videoFormat">
            <el-radio label="normal">普通视频</el-radio>
            <el-radio label="rgb-alpha-mask">透明视频（RGB+Alpha 蒙版）</el-radio>
          </el-radio-group>
          <div class="format-tip">
            透明视频仅选择由“Alpha Video Converter”转换生成的 RGB+Alpha 蒙版 MP4。
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="commitFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="submitOrderCommit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加文本显示弹窗 -->
    <el-dialog
      title="详细内容"
      :visible.sync="textDialogVisible"
      width="50%">
      <div style="word-break: break-all;">{{ currentText }}</div>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  getOrderList,
  addOrder,
  updateOrder,
  deleteOrder,
  getOrderDetail,
  getGoodsList,
  submitOrder
} from '@/api/demo/arLoveMsg'
import JSZip from 'jszip'

import printJS from 'print-js'
// 上传视频
import UploadVideo from '@/components/uploadVideo/index.vue'
export default {
  name: 'arMsgOrder',
  components: {
    UploadVideo
  },
  data () {
    return {
      commitFormVisible: false,
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      confirmLoading: false,
      dialogFormVisible: false,
      keywordList: [],
      commitForm: {
        id: '',
        type: 0,
        arMsgRes: '',
        videoFormat: ''
      },
      form: {
        id: '',
        goodsId: '',
        name: '', // 名称
        mobile: '', // 客户手机号
        kefuRemark: '' // 客服备注,
      },
      goodsList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        status: null,
        keyword: ''
      },
      listLoading: false,
      commitRules: {
        arMsgRes: [
          {
            required: true,
            message: '请上传制作结果',
            trigger: 'blur'
          }
        ],
        videoFormat: [
          {
            required: true,
            message: '请选择视频类型',
            trigger: 'change'
          }
        ]
      },
      textCommitRules: {
        arMsgRes: [
          {
            required: true,
            message: '请输入文字密语',
            trigger: 'blur'
          }
        ]
      },
      rules: {
        goodsId: [
          {
            required: true,
            message: '请选择商品',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '名称',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '客户手机号',
            trigger: 'blur'
          }
        ],
        kefuRemark: [
          {
            required: false,
            message: '客服备注',
            trigger: 'blur'
          }
        ]
      },
      textDialogVisible: false,
      currentText: ''
    }
  },
  created () {
    this.getSearch()
    this.getGoodsList()
  },
  watch: {
  },
  methods: {
    copy (text) {
      try {
        // 创建临时input元素
        const input = document.createElement('input')
        input.setAttribute('readonly', 'readonly') // 防止在ios中弹出键盘
        input.value = text
        document.body.appendChild(input)
        // 选中文本
        input.select()
        // 兼容ios
        input.setSelectionRange(0, 9999)
        // 执行复制命令
        if (document.execCommand('copy')) {
          document.body.removeChild(input)
          this.$message.success('复制成功')
        } else {
          document.body.removeChild(input)
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败')
      }
    },
    selectGoods (id) {
      this.form.goodsId = id
      // 刷新渲染
      this.$forceUpdate()
      // 刷新表单校验
      this.$refs.form.validateField('goodsId')
    },
    getGoodsList () {
      getGoodsList(
        {
          currentPage: 1,
          pageSize: 1000
        }
      ).then(res => {
        this.goodsList = res.records
      })
    },
    openVideo (url) {
      window.open(url, '_blank')
    },

    submitForm () {
      let that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (that.dialogStatus == 'create') {
            // loading
            that.confirmLoading = true
            addOrder(that.form).then(res => {
              that.$message({
                message: '添加成功',
                type: 'success',
                center: true
              })
              that.dialogFormVisible = false
              that.confirmLoading = false
              that.getSearch()
            }).finally(() => {
              that.confirmLoading = false
            })
          } else {
            that.confirmLoading = true
            updateOrder(that.form.id, that.form).then(res => {
              that.$message({
                message: '修改成功',
                type: 'success',
                center: true
              })
              that.dialogFormVisible = false
              that.getSearch()
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        }
      })
    },
    submitOrder (id, type) {
      this.commitForm = {
        id: id,
        type: Number(type) === 1 ? 1 : 0,
        arMsgRes: '',
        videoFormat: ''
      }
      this.commitFormVisible = true
      this.$nextTick(() => {
        this.$refs.commitForm.clearValidate()
      })
    },
    submitOrderCommit () {
      let that = this
      this.$refs.commitForm.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          const payload = {
            arMsgRes: that.commitForm.arMsgRes
          }
          if (that.commitForm.type === 0) {
            payload.videoFormat = that.commitForm.videoFormat
          }
          submitOrder(that.commitForm.id, payload).then(res => {
            that.$message({
              message: '提交成功',
              type: 'success',
              center: true
            })
            that.commitFormVisible = false
            that.getSearch()
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },
    downloadMaterial (id, paramsJson) {
      this.$loading({
        lock: true,
        text: '正在下载素材...'
      })

      let params = JSON.parse(paramsJson)
      let zip = new JSZip()

      // 使用Promise.all处理所有下载
      const downloads = params.map(async param => {
        if (!param.value) return

        try {
          if (param.type == 'text') {
            zip.file(param.title + '.txt', param.value)
          } else {
            const response = await fetch(param.value)
            if (!response.ok) {
              throw new Error(`下载失败: ${response.statusText}`)
            }
            const blob = await response.blob()
            const ext = param.type === 'image' ? '.png' : param.type === 'audio' ? '.acc' : ''
            zip.file(param.title + ext, blob)
          }
        } catch (err) {
          this.$message.error(`${param.title}下载失败: ${err.message}`)
        }
      })

      Promise.all(downloads)
        .then(() => {
          return zip.generateAsync({ type: 'blob' })
        })
        .then(content => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(content)
          link.download = id + '的素材.zip'
          link.click()
          this.$loading().close()
          this.$message.success('下载完成')
        })
        .catch(err => {
          this.$loading().close()
          this.$message.error('打包下载失败')
          console.error(err)
        })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getOrderList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.form = {
        id: '',
        goodsId: '',
        name: '', // 名称
        mobile: '', // 客户手机号
        kefuRemark: '' // 客服备注
      }
      this.confirmLoading = false
      this.$refs.form.resetFields()
    },
    // 编辑
    editCard (id) {
      this.confirmLoading = false
      this.dialogFormVisible = true
      getOrderDetail(id).then(res => {
        this.form = res
        this.form.id = id
        this.dialogStatus = 'update'
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOrder(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 打印机打印二维码 尺寸 30 * 30 中心位置
    printQrCode (url) {
      printJS({
        printable: url,
        type: 'image',
        imageStyle: `
          width: 24mm;  /* 减小图片尺寸以留出边距 */
          height: 22mm;  /* 减小图片尺寸以留出边距 */
          display: block;
          margin: 2mm auto;  /* 上下留2mm边距，左右自动居中 */
          object-fit: contain;
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        `,
        style: `
          @page {
            size: 28mm 26mm;  /* 保持纸张总大小不变 */
            margin: 0;
            padding: 0;
          }
          @media print {
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            img {
              max-width: 24mm;
              max-height: 22mm;
            }
          }
        `,
        documentTitle: '热敏打印',
        honorColor: false,
        onLoadingStart: () => {
          this.$loading({
            lock: true,
            text: '准备打印...'
          })
        },
        onLoadingEnd: () => {
          this.$loading().close()
        }
      })
    },
    showTextDialog (row) {
      this.currentText = row.arMsgRes
      this.textDialogVisible = true
    },
    toggleText (row) {
      this.$set(row, 'isExpanded', !row.isExpanded)
    }
  }
}
</script>
<style lang="scss" scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.active {
  color: #409EFF;
}
.format-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.prompt-tip {
  font-size: 12px;
  color: #999;
  margin: 10px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 10px;
}

.test-prompt {
  margin-top: 20px;
  .test-prompt-content {
    display: flex;
    align-items: center;
    .test-prompt-content-item-result {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .test-prompt-content-item-result-item {
        width: 300px;
        margin: 10px;
        border: 1px solid #ccc;
        padding: 10px;
        border-radius: 10px;
        .test-prompt-content-item-result-item-name {
          font-size: 14px;
          font-weight: 600;
        }
        .test-prompt-content-item-result-item-type {
          font-size: 12px;
          color: #999;
        }
        .test-prompt-content-item-result-item-result {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
.text-ellipsis {
  max-width: 100%;
  cursor: pointer;
  color: #409EFF;
}
</style>
